import script from "./sbx-free-style.ce.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./sbx-free-style.ce.vue?vue&type=script&setup=true&lang=ts"
export * from "./sbx-free-style.ce.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./sbx-free-style.ce.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__